
// frontend/geopolitikia/src/components/MobileNews.jsx
import React from 'react';
import Journal from "./JournalMobile.jsx";

const MobileNews = ({ selectedYear, setSelectedYear, sortedYears, previousArticles, setShowNewspaperPopup, setShowArchivePopup, playerCountry }) => {
  return (
    <div className="bg-slate-900 rounded-lg max-w-full max-h-full overflow-auto w-full custom-scrollbar">
      <div className="">
        {!selectedYear ? (<>
          <div className="p-4 border-b border-slate-700">
            <div className="flex items-center justify-between">
              <h2 className="text-white font-bold">Archives</h2>
            </div>
          </div>
          <div className="space-y-3">
            <h3 className="text-white mb-4">Choisissez une année :</h3>
            {sortedYears.map(year => (
              <button
                key={year}
                onClick={() => setSelectedYear(year)}
                className="w-full bg-slate-700 hover:bg-slate-600 text-white py-3 px-4 rounded-lg transition-colors"
              >
                📅 {year}
              </button>
            ))}
          </div></>
        ) : (
          <Journal
            articles={previousArticles.filter(article => String(article.year) === String(selectedYear))}
            onClose={() => {
              setShowNewspaperPopup(false);
              setShowArchivePopup(false);
              setSelectedYear(null);
            }}
            backChoice={() => {
              setShowNewspaperPopup(false);
              setShowArchivePopup(true);
              setSelectedYear(null);
            }}
            setShowArchivePopup={setShowArchivePopup}
            setSelectedYear={setSelectedYear}
            playerCountry={playerCountry}
          />
        )}
      </div>
    </div>
  );
};

export default MobileNews;
